/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import * as React from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import View from './view';
import applyNesting from './apply-nesting';

type Props = React.ComponentProps<typeof View> & {
  selectable?: boolean;
  numberOfLines?: number;
};

const Base = ({ children, ...props }: Props) => (
  <View {...props}>{applyNesting(children)}</View>
);

const Text: StyledComponent<React.ComponentProps<typeof Base>> = styled(Base)(
  (props) => ({
    borderWidth: 0,
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'inline',
    fontSize: '0.875rem',
    fontStyle: 'inherit',
    fontVariant: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    margin: 0,
    padding: 0,
    textDecorationLine: 'none',
    whiteSpace: 'pre-line',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    ...(props.inline
      ? {
          fontFamily: 'inherit',
          fontSize: 'inherit',
          whiteSpace: 'inherit',
        }
      : {}),
    ...(props.selectable === false ? { userSelect: 'none' } : {}),
    ...(props.numberOfLines === 1
      ? {
          maxWidth: 100,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }
      : {}),
    fontSmoothing: 'antialiasing',
  }),
);

export default Text;
